import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer, ProgressBox, ProgressStat } from '../styles';
import { polarColors } from '../constants';

const getColor = value => {
  if (value < 25) {
    return polarColors[4];
  }
  if (value < 50) {
    return polarColors[3];
  }
  if (value < 75) {
    return polarColors[1];
  }
  return polarColors[0];
};

const DysfunctionalBeliefsThirdPage = ({ user, background, number }) => {
  const rolAyudaProfesional = parseFloat(user['Rol de la ayuda profesional']);
  const creenciasGenero = parseFloat(user['Género']);
  const isValidGeneroValue = creenciasGenero !== undefined && !isNaN(creenciasGenero);
  // console.log({ user });
  // console.log({ rolAyudaProfesional, creenciasGenero, isValidGeneroValue });
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>3.2.4. Rol de la ayuda profesional</h3>
          <p className='justified'>
            Un obstáculo común en el proceso de elección de carrera es la
            creencia disfuncional sobre el papel de la ayuda profesional. Se
            puede{' '}
            <strong>
              depositar una confianza excesiva en pruebas psicológicas u
              actividades de orientación vocacional, esperando que estas
              proporcionen una "solución mágica"
            </strong>{' '}
            a la incertidumbre. Este tipo de creencias puede llevar a que
            estudiantes minimicen sus propios esfuerzos en el proceso de toma de
            decisiones, dejando que un tercero tome la decisión por ellos.
          </p>
          {/* <p className='justified'>
            Ejemplo: un estudiante puede optar por una carrera en derecho solo
            porque una prueba de orientación vocacional indicó que tenía
            habilidades verbales y analíticas fuertes, aunque sus intereses y
            pasiones pueden estar en otro lugar.
          </p> */}
          <div className='paragraph'>¿Cómo afrontar esta situación?</div>
          <ul className='text-list'>
            <li>- Involucrarse activamente en la decisión.</li>
            <li>- Autoexploración y exploración de intereses y habilidades.</li>
            <li>- Trabajar la autonomía.</li>
          </ul>
          <div className='progress-info-group'>
            <div className='progress-info'>
              <div className='progress-details-single'>
                <ProgressBox
                  progress={rolAyudaProfesional}
                  backColor={() => getColor(rolAyudaProfesional)}
                >
                  <div className='progress'></div>
                </ProgressBox>
                <ProgressStat>{rolAyudaProfesional}</ProgressStat>
              </div>
            </div>
          </div>
          <br />
          {isValidGeneroValue && (
            <>
              <h3>3.2.5. Creencias en relación al género</h3>
              <p className='justified'>
                Las creencias disfuncionales respecto al género pueden ejercer
                una influencia significativa en la elección de una carrera. Hay
                estudiantes que pueden sostener la{' '}
                <strong>
                  creencia de que ciertas carreras son específicas de un género
                  determinado
                </strong>
                , lo que puede llevar a descartar opciones de carreras
                potencialmente interesantes y adecuadas debido a este sesgo de
                género.
              </p>
              {/* <p className='justified'>
            Ejemplo: un estudiante masculino interesado en enfermería puede
            evitar seguir esta carrera debido a la percepción errónea de que es
            un campo predominantemente femenino. De la misma manera, una
            estudiante femenina con aptitudes para la ingeniería puede decidir
            no seguir esta carrera debido a la creencia de que es un campo
            dominado por hombres.
          </p> */}
              <div className='paragraph'>¿Cómo afrontar esta situación?</div>
              <ul className='text-list'>
                <li>
                  - Conversar con personas que trabajen en áreas que
                  tradicionalmente se atribuyen a un género particular.
                </li>
                <li>- Buscar información precisa sobre las carreras.</li>
              </ul>
              <div className='progress-info-group'>
                <div className='progress-info'>
                  <div className='progress-details-single'>
                    <ProgressBox
                      progress={creenciasGenero}
                      backColor={() => getColor(creenciasGenero)}
                    >
                      <div className='progress'></div>
                    </ProgressBox>
                    <ProgressStat>{creenciasGenero}</ProgressStat>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default DysfunctionalBeliefsThirdPage;
